//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
//#endregion
//#region Icons
import { 
    Cell, DateTimeCell } from "./styles";
//#endregion
//#region Utils
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const Tablet = ({
    brand,
    model,
    serial,
    barcode,
    details,
    date,
    time,
    changes
}) => {
    //#region Functions
    const getClassNameCell = fieldIsChanged => {
        const classList = ["small", "ellipsis"];
        fieldIsChanged && classList.push("changed");
        return classList.join(" ");
    };
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassNameCell(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <Cell {...getPropsForCell(changes.brand)}>
                    <h5 title={brand}>{brand}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.model)}>
                    <h5 title={model}>{model}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.serial)}>
                    <h5 title={serial}>{serial}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.barcode)}>
                    <h5 title={barcode}>{barcode}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.details)}>
                    <h5 title={details}>{details || "-"}</h5>
                </Cell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateTimeCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={time}>{time}</h5>
                </DateTimeCell>
            </TDef>
        </Container>
    );
}

const PC = ({
    brand,
    barcode,
    details,
    date,
    time,
    changes
}) => {
    //#region Functions
    const getClassNameCell = fieldIsChanged => {
        const classList = ["small", "ellipsis"];
        fieldIsChanged && classList.push("changed");
        return classList.join(" ");
    }
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassNameCell(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <Cell {...getPropsForCell(changes.brand)}>
                    <h5 title={brand}>{brand}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.barcode)}>
                    <h5 title={barcode}>{barcode}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.details)}>
                    <h5 title={details}>{details || "-"}</h5>
                </Cell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateTimeCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={time}>{time}</h5>
                </DateTimeCell>
            </TDef>
        </Container>
    );
}

const GroupRoom = ({
    capacity,
    environment,
    address,
    details,
    date,
    time,
    changes
}) => {
    //#region Functions
    const getClassNameCell = fieldIsChanged => {
        const classList = ["small", "ellipsis"];
        fieldIsChanged && classList.push("changed");
        return classList.join(" ");
    }
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassNameCell(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <Cell {...getPropsForCell(changes.capacity)}>
                    <h5 title={capacity}>{capacity}</h5>
                </Cell>
            </TDef>
            {environment && 
            <TDef>
                <Cell {...getPropsForCell(changes.environment)}>
                    <h5 title={environment}>{environment}</h5>
                </Cell>
            </TDef>}
            {environment && 
            <TDef>
                <Cell {...getPropsForCell(changes.address)}>
                    <h5 title={address}>{address || "-"}</h5>
                </Cell>
            </TDef>}
            <TDef>
                <Cell {...getPropsForCell(changes.details)}>
                    <h5 title={details}>{details || "-"}</h5>
                </Cell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateTimeCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={time}>{time}</h5>
                </DateTimeCell>
            </TDef>
        </Container>
    );
}

export default {
    Tablet,
    PC,
    GroupRoom
};